// extracted by mini-css-extract-plugin
export default {"mainContainer":"PageError_mainContainer__OsKHV","image":"PageError_image__-BeqX","title":"PageError_title__eTTMk","text":"PageError_text__mKKKb"};